/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import useReduxData from '../../../Hooks/useReduxData';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment-timezone';
import { addNewAllergiesValidation, addNewChronicDiseaseValidation, addNewSymptomsValidation, addNewTestsValidation, addReportValidation, addvaccinationValidation, checkoutRXValidation, medicineValidation, treatmentPlanValidation } from '../../../Context/Validation';
import useMinimumDate from '../../../Hooks/useMinimumDate';
import useMuiCompontent from '../../../Hooks/useMuiCompontent';
import { useReactToPrint } from 'react-to-print';
import { ASSIGN_VACCINATION_CALENDAR, DELETE_AGENDA, INSERT_CHECKOUT_APPOINTMENT, INSERT_EPRESCRIPTION, INSERT_SETUP, INSERT_TEST_REPORT, SETUP_LIST } from '../../Repository/AppointmentsRepo';
import { ADD_TREATMENT_PLAN, INSERT_MEDICINE, LIFESTYLE_LIST, MEDICINE_LIST, TREATMENT_PLAN_LIST } from '../../Repository/SettingRepo';
import { GET_EPRESCRIPTION_DETAILS, TEST_REPORT_LIST, VACCINATION_CALENDAR_PATIENT } from '../../Repository/PatientRepo';
import { medicines, RoleTitle } from '../../../Context/constants';
import { ColorlibConnector, ColorlibStepIcon, headCells, steps } from '../constant';
import { UPLOAD_FILE_PDF } from '../../Repository/ProfileRepo';
import { VACCINATION_CATEGORY_LIST, VACCINATION_FORM_LIST } from '../../Repository/VaccinationRepo';
import useHtml2canvas from '../../../Hooks/useHtml2canvas';
const useCheckOut = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const [formNumber, setFormNumber] = useState(0)
  const [testReport, setTestReport] = useState([])
  const [assignVaccinationcalenderList, setAssignVaccinationcalenderList] = useState([])
  const [ListVaccinationCategory, setListVaccinationCategory] = useState([])
  const [VaccinationFormList, setVaccinationFormList] = useState([])
  const [MultipleReportData, SetMultipleReportData] = useState([])
  const [medicineList, setMedicineList] = useState([])
  const [treatmentPlanList, setTreatmentPlanList] = useState([])
  const [selectedPlan, setSelectedPlan] = useState([])
  const [completed] = React.useState({});
  const [symptonData, setSymptonData] = useState([])
  const [chronicData, setChronicData] = useState([])
  const [testRequestData, setTestRequestData] = useState([])
  const [listSelectedMedicines, setListSelectedMedicines] = useState([])
  const [controller, setController] = useState({ page: 1, rowsPerPage: 10 });
  const [paginationTotalCount, setPaginationTotalCount] = useState(0)
  const [allergiesList, setAllergiesList] = useState([])
  const [LifeStyleList, setLifeStyleList] = useState([])
  const [Url, setUrl] = useState(null);
  const [UploadReportType, setUploadReportType] = useState(null)
  const [vaccinationSerialNumberView, setVaccinationSerialNumberView] = useState({
    isOpen: false,
    Path: null
  })
  const [removeButton, setremoveButton] = useState(false)
  const [Type] = useState({
    ALLERGY: "ALLERGY",
    DISEASE: "DISEASE",
    SYMPTOM: "SYMPTOM",
    TESTL: "TEST"
  })
  const [loader, setLoader] = useState(false)
  const [modal, setModal] = useState({ Symptoms: false, ChronicDisease: false, Tests: false, Allergies: false })
  const [EPrescriptionViewModal, setEPrescriptionViewModal] = useState({
    open: false,
    data: null
  })
  const [openModal, setOpenModal] = useState({
    add: false,
    clonePlan: false,
    tests: false,
    addMedicine: false,
    deleteEprescription: false,
    deleteReport: false,
    deleteVaccination: false,
    showTestReport: false,
    createTestReport: false,
    assginVaccination: false,
    viewVaccinationForm: false,
    downloadVaccinationForm: false,
    printVaccinationForm: false,

    data: null,
    previoursData: null
  })
  const { reduxData: userdata } = useReduxData("userDataRDX")
  const { reduxData: AgendaDetails } = useReduxData("AgendaDetailsRDX")
  const { contentRef, downloadContent } = useHtml2canvas()
  const isFrontDeskPermission = userdata?.roleTitle === RoleTitle?.FRONT_DESK
  const { minimumdate } = useMinimumDate()
  const { CustomButton } = useMuiCompontent()
  const { id } = useParams()
  let dateTime = moment().utc()
  const navigate = useNavigate()
  const componentRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const totalSteps = () => {
    return steps.length;
  };
  const completedSteps = () => {
    return Object.keys(completed).length;
  };
  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };
  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };
  const handleStep = (step) => () => {
    setActiveStep(step);
  };
  const handleNext = () => {
    const newActiveStep = isLastStep() && !allStepsCompleted() ? steps.findIndex((step, i) => !(i in completed)) : activeStep + 1;
    setActiveStep(newActiveStep);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  useEffect(() => {
    if (activeStep === 2) {
      getreportList()
    }
    if (activeStep === 3) {
      getListSelectedMedicines()
    }
    if (activeStep === 4) {
      getAssignVaccinationCalendarList()
    }

  }, [controller])

  useEffect(() => {
    setController({ page: 1, rowsPerPage: 10 })
    if (activeStep === 1) {
      getSetupList(Type?.ALLERGY)
      getSetupList(Type?.DISEASE)
      getSetupList(Type?.SYMPTOM)
    }
    if (activeStep === 3) {
      getMedicineList()
      getTesttList()
      getTreatmentPlanList()
    }
    if (activeStep === 4) {
      getVaccinationCategoryList()
    }
  }, [activeStep])

  useEffect(() => {
    getLifeStyleList()
  }, [])
  useEffect(() => {
    if (removeButton) {
      if (openModal.downloadVaccinationForm) {
        downloadContent()
        handleClosedModal("downloadVaccinationForm")
      }
      if (openModal.printVaccinationForm) {
        handlePrint()
        handleClosedModal("printVaccinationForm")
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removeButton])


  //List Life Style
  const getLifeStyleList = async () => {
    setLoader(true)
    const payload = {
      activeStatus: true,
      userId: (userdata.roleTitle === RoleTitle.STAFF || userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
    };
    try {
      let response = await LIFESTYLE_LIST(payload)
      let LifeStylearray = []
      response.data?.forEach((cur) => {
        LifeStylearray.push({
          [`habit_${cur?.lifeStyleId}`]: true,
          [`pastHabit_${cur?.lifeStyleId}`]: true,
          record: "",
          consumption: "",
          TimeFrame: "days",
          ...cur
        })
      })
      setLifeStyleList(LifeStylearray)
    } catch (error) {
      toast.error(error.message)
      setLifeStyleList([])
    }
    finally {
      setLoader(false)
    }
  }
  async function getSetupList(type) {
    const payload = {
      activeStatus: true,
      providerId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.providerId : userdata?.userId,
      staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
      type,
    };
    try {
      let response = await SETUP_LIST(payload)
      if (type === Type?.ALLERGY) setAllergiesList(response?.data)
      if (type === Type?.DISEASE) setChronicData(response?.data)
      if (type === Type?.SYMPTOM) setSymptonData(response?.data)
    } catch (error) {
      if (type === Type?.ALLERGY) setAllergiesList([])
      if (type === Type?.DISEASE) setChronicData([])
      if (type === Type?.SYMPTOM) setSymptonData([])
    }
  }
  const getListSelectedMedicines = async () => {
    let payload = {
      // prescriptionNumber: AgendaDetails?.prescriptionNumber,
      appointmentId: AgendaDetails?.apptId,
      page: controller.page,
      count: controller.rowsPerPage,
    }
    try {
      let response = await GET_EPRESCRIPTION_DETAILS(payload)
      setListSelectedMedicines(response.data)
      setTestRequestData(response?.tests)
      setLoader(false)
      setPaginationTotalCount(response?.totalCount)
    } catch (error) {
      setPaginationTotalCount(0)
      setListSelectedMedicines([])
      setTestRequestData([])
      setLoader(false)
    }
  }
  const addVitals = useFormik({
    initialValues: {
      bp: '',
      pulse: '',
      weight: '',
      height: '',
      temperature: ''
    },
    validationSchema: "",
    onSubmit: (values) => {
    }
  })
  const handleChangeLifeStyle = (e, index, checked, data) => {
    const { value, name, type } = e?.target
    const tempLifeStyleList = [...LifeStyleList]
    if (type === "textarea" || type === "select-one" || type === "number") {
      if ("consumption" === name && value < 0) {
        tempLifeStyleList[index][name] = 0
      } else {
        tempLifeStyleList[index][name] = value
      }

    } else {
      tempLifeStyleList[index][name] = checked
      if (data?.[`habit_${data?.lifeStyleId}`] == true) {
        tempLifeStyleList[index][`pastHabit_${data?.lifeStyleId}`] = true
        tempLifeStyleList[index][`record`] = ""
      } else {
        tempLifeStyleList[index][`consumption`] = ""
        tempLifeStyleList[index][`TimeFrame`] = "days"
        tempLifeStyleList[index][`record`] = ""
      }
      if (data?.[`pastHabit_${data?.lifeStyleId}`] == false) {
        tempLifeStyleList[index][`record`] = ""
      }

    }
    setLifeStyleList(tempLifeStyleList)
  }
  const LifeStyleTimeFrame = (TimeFrame, index) => {
    const tempLifeStyleList = [...LifeStyleList]
    tempLifeStyleList[index][`TimeFrame`] = TimeFrame
    setLifeStyleList(tempLifeStyleList)
  }
  const AddAllergies = useFormik({
    initialValues: {
      Allergies: [],
    },
  })
  const addSymptoms = useFormik({
    initialValues: {
      symptoms: [],
    },
  })
  const addChronicDisease = useFormik({
    initialValues: {
      chronicDisease: [],
    },
  })
  // const addTestsRequested = useFormik({
  //   initialValues: {
  //     tests: [],
  //   },
  // })
  const addFollowUpDate = useFormik({
    initialValues: {
      dateTime: "",
    },
  })
  const addDiagnosis = useFormik({
    initialValues: {
      diagnosis: "",
    },
  })
  const LifeStyleData = (iteam) => {

    return iteam?.map((cur, index) => {
      return {
        lifeStyleName: cur?.lifeStyleName,
        habit: cur?.[`habit_${cur?.lifeStyleId}`],
        pastHabit: cur?.[`pastHabit_${cur?.lifeStyleId}`],
        consumption: cur?.consumption,
        record: cur?.record
      }
    })

  }
  const saveAllData = async () => {
    const data = {
      providerId: (userdata.roleTitle === RoleTitle.STAFF || userdata?.roleTitle === RoleTitle?.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
      frontdeskId: userdata?.roleTitle === RoleTitle?.FRONT_DESK ? userdata?.userId : undefined,
      roleTitle: userdata?.roleTitle,
      staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
      patientId: id,
      appointmentId: AgendaDetails?.apptId,
      dateTime: dateTime,
      bp: addVitals?.values?.bp,
      pulse: addVitals?.values?.pulse,
      weight: addVitals?.values?.weight,
      weightType: "KG",
      height: addVitals?.values?.height,
      heightType: "CM",
      temperature: addVitals?.values?.temperature,
      temperatureType: "F",
      diagnosis: addDiagnosis?.values?.diagnosis,
      followUpDate: addFollowUpDate?.values?.dateTime,
      lifestyles: LifeStyleData(LifeStyleList),
      allergies: AddAllergies?.values?.Allergies?.map((cur) => cur?.name),
      symptoms: addSymptoms?.values?.symptoms?.map((cur, index) => cur?.name),
      chronicDisease: addChronicDisease?.values?.chronicDisease?.map((cur, index) => cur?.name),
      tests: testRequestData?.map((cur) => cur?.testsName),
    }
    setLoader(true)
    try {
      let response = await INSERT_CHECKOUT_APPOINTMENT(data)
      toast.success(response.message)
      navigate(`/patient-bill?patientId=${id}&appointmentId=${AgendaDetails?.apptId}&providerId=${(userdata.roleTitle === RoleTitle.STAFF || userdata?.roleTitle === RoleTitle?.FRONT_DESK) ? userdata?.providerId : userdata?.userId}`)
    } catch (error) {
      toast.error(error.message)
    }
    finally {
      setLoader(false)
    }

  }
  const newAddSymptoms = useFormik({
    initialValues: {
      Symptoms: ""
    },
    validationSchema: addNewSymptomsValidation,
    onSubmit: (values) => {
      newAdd_Symptoms_Chronic_TestsFun(values?.Symptoms, Type?.SYMPTOM, "Symptoms")
      newAddSymptoms.resetForm()
    }
  })
  const newAddChronicDisease = useFormik({
    initialValues: {
      ChronicDisease: ""
    },
    validationSchema: addNewChronicDiseaseValidation,
    onSubmit: (values) => {
      newAdd_Symptoms_Chronic_TestsFun(values?.ChronicDisease, Type?.DISEASE, "ChronicDisease")
      newAddChronicDisease.resetForm()
    }
  })
  // const newAddTestsRequested = useFormik({
  //   initialValues: {
  //     Tests: ""
  //   },
  //   validationSchema: addNewTestsValidation,
  //   onSubmit: (values) => {
  //     newAdd_Symptoms_Chronic_TestsFun(values?.Tests, Type.TESTL, "Tests")
  //     newAddTestsRequested.resetForm()
  //   }
  // })
  const newAddallergies = useFormik({
    initialValues: {
      allergies: ""
    },
    validationSchema: addNewAllergiesValidation,
    onSubmit: (values) => {
      newAdd_Symptoms_Chronic_TestsFun(values?.allergies, Type.ALLERGY, "Allergies")
      newAddallergies.resetForm()
    }
  })
  const newAdd_Symptoms_Chronic_TestsFun = async (value, type, modalKey) => {
    setLoader(true)
    let payload = {
      name: value,
      type,
      providerId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.providerId : userdata?.userId,
      staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
    }
    try {
      let response = await INSERT_SETUP(payload)
      toast.success(response.message)
      setModal((pre) => ({ ...pre, [modalKey]: false }))
      if (type === Type?.SYMPTOM) getSetupList(Type?.SYMPTOM)
      if (type === Type?.DISEASE) getSetupList(Type?.DISEASE)
      if (type === Type?.TESTL) getSetupList(Type?.TESTL)
      if (type === Type?.ALLERGY) getSetupList(Type?.ALLERGY)
      setLoader(false)
    } catch (error) {
      toast.error(error.message)
      setLoader(false)
    }
  }
  const openModalFun = (type) => {
    setModal((pre) => ({ ...pre, [type]: true }))
  }
  const handalSearchAbleSelectBox = (event, newValue, name) => {
    if (name === "Allergies") AddAllergies.setFieldValue(name, newValue);
    if (name === "symptoms") addSymptoms.setFieldValue(name, newValue);
    if (name === "chronicDisease") addChronicDisease.setFieldValue(name, newValue);
    if (name === "category") {
      addvaccination.setFieldValue("category", newValue);
      getlistVaccinationForm(newValue?.[0]?.vaccinationCategoryId)
      addvaccination.setFieldValue("vaccinationForm", []);
    }
    if (name === "vaccinationForm") {
      addvaccination.setFieldValue("vaccinationForm", newValue);
    }
  }



  // after changes

  async function getMedicineList() {
    setLoader(true);
    const payload = {
      activeStatus: true,
      providerId: (userdata.roleTitle === RoleTitle.STAFF || userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
      frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
    };
    try {
      let response = await MEDICINE_LIST(payload)
      setMedicineList(response?.data?.map((cur) => ({ ...cur, medicine: `${cur?.name} (${cur?.dose} ${cur?.unit}) - ${cur?.medicineType} (${cur?.brandName})` })));
      setLoader(false)
    } catch (error) {
      setMedicineList([])
      setLoader(false)
    }
  }

  async function getTreatmentPlanList() {
    setLoader(true)
    const payload = {
      activeStatus: true,
      providerId: (userdata.roleTitle === RoleTitle.STAFF || userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
      frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
      roleTitle: userdata.roleTitle,
      patientId: id,
    };
    try {
      let response = await TREATMENT_PLAN_LIST(payload)
      setTreatmentPlanList(response?.data?.map((cur) => ({
        ...cur,
        fullName: `${cur?.name} ( ${cur?.planTypeField || cur?.planType} ) ${id === cur?.patientId ? "*" : ""}`,
      })))
      setLoader(false)
    } catch (error) {

      setTreatmentPlanList([])
      setLoader(false)
    }
  }

  async function getTesttList(testIds) {
    const payload = {
      activeStatus: true,
      providerId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.providerId : userdata?.userId,
      staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
      type: "TEST",
    };
    try {
      let response = await SETUP_LIST(payload)
      const testData = response?.data || [];
      setTestReport(testData);
      if (testIds?.length) {
        const tests = testData.filter((cur) => testIds.some((item) => item?.testsName === cur?.name));
        formik.setFieldValue("tests", tests)
      }
    } catch (error) {
      setTestReport([])
    }
  }

  // report list
  const getreportList = async () => {
    setLoader(true)
    let payload = {
      page: controller.page,
      count: controller.rowsPerPage,
      patientId: AgendaDetails?.id,
      appointmentId: AgendaDetails?.apptId,
      providerId: (userdata.roleTitle === RoleTitle.STAFF || userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
      frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
    }
    try {
      let response = await TEST_REPORT_LIST(payload)
      SetMultipleReportData(response?.data)
      setPaginationTotalCount(response?.totalCount)
      setLoader(false)
    } catch (error) {
      setPaginationTotalCount(0)
      SetMultipleReportData([])
      setLoader(false)
    }
  }

  const getAssignVaccinationCalendarList = async () => {
    const payload = {
      page: controller.page,
      count: controller.rowsPerPage,
      patientId: AgendaDetails?.id,
      appointmentId: AgendaDetails?.apptId,
      providerId: (userdata.roleTitle === RoleTitle.STAFF || userdata?.roleTitle === RoleTitle?.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
      staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
      frontdeskId: userdata?.roleTitle === RoleTitle?.FRONT_DESK ? userdata?.userId : undefined,
    };
    setLoader(true)
    try {
      let response = await VACCINATION_CALENDAR_PATIENT(payload)
      setAssignVaccinationcalenderList(response?.data?.map((cur) => {
        return { ...cur, doctorName: `${cur?.Doctor} ${cur?.doctorLastName}` }
      }))
      setLoader(false)
      setPaginationTotalCount(response?.totalCount)
    } catch (error) {
      setAssignVaccinationcalenderList([])
      setPaginationTotalCount(0)
      setLoader(false)
    }

  }

  // vaccination category list
  const getVaccinationCategoryList = async () => {
    const payload = {
      activeStatus: true,
      roleTitle: userdata?.roleTitle,
      providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK || userdata.roleTitle === RoleTitle.STAFF) ? userdata?.providerId : userdata?.userId,
      frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
    };
    setLoader(true)
    try {
      let response = await VACCINATION_CATEGORY_LIST(payload)
      setListVaccinationCategory(response?.data)
      setLoader(false)
    } catch (error) {
      setListVaccinationCategory([])
      setLoader(false)
    }

  }
  // vaccination form list
  const getlistVaccinationForm = async (id) => {
    setLoader(true)
    const payload = {
      activeStatus: true,
      vaccinationCategoryId: id,
      publishStatus: true,
      providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK || userdata.roleTitle === RoleTitle.STAFF) ? userdata?.providerId : userdata?.userId,
      frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
      staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,

    };
    try {
      let response = await VACCINATION_FORM_LIST(payload)
      setVaccinationFormList(response?.data)
      setLoader(false)
    } catch (error) {
      setVaccinationFormList([])
      setLoader(false)
    }
  }
  const formik = useFormik({
    initialValues: {
      tests: [],
      followUp: "",
      medicines: [
        { ...medicines }
      ],
    },
    validationSchema: checkoutRXValidation,
    onSubmit: async (values, { resetForm }) => {
      const { clone, ...restValue } = values
      let payload = {
        patientId: AgendaDetails?.id,
        appointmentId: AgendaDetails?.apptId,
        appointmentNumber: AgendaDetails?.apptNumber,
        providerId: (userdata.roleTitle === RoleTitle.STAFF || userdata?.roleTitle === RoleTitle?.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
        staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
        frontdeskId: userdata?.roleTitle === RoleTitle?.FRONT_DESK ? userdata?.userId : undefined,
        roleTitle: userdata.roleTitle,
        followUp: restValue?.followUp,
        rx: restValue?.medicines?.map((cur) => ({
          ...cur,
          medicineId: cur?.medicine?.[0]?.medicineId,
          medicineType: cur?.medicine?.[0]?.medicineType,
          dose: cur?.medicine?.[0]?.dose,
          unit: cur?.medicine?.[0]?.unit,
          customMedCount: cur?.timeofmedicine === "HOURS" ? cur?.timeofmedicinenumberForHours : cur?.timeofmedicinenumberForDays,
          customMedCountTimeFrame: cur?.medCountType === "STANDARD" ? null : cur?.timeofmedicine,
          timeofmedicine: undefined,
          timeofmedicinenumberForDays: undefined,
          timeofmedicinenumberForHours: undefined,
          medicine: undefined
        })),
        tests: values?.tests?.map((cur) => cur?.name)
      }
      setLoader(true)
      try {
        let response = await INSERT_EPRESCRIPTION(payload)
        toast.success(response?.message)
        handleClosedModal("add", true)
        setSelectedPlan([])
        setFormNumber(0)
        setLoader(false)
        resetForm()
        await getListSelectedMedicines()
      } catch (error) {
        toast.error(error?.message)
        setLoader(false)
      }
    },
  });


  const handleClonePlan = useFormik({
    initialValues: {
      name: "",
      followUp: "",
      planType: "",
      planTypeField: "",
      tests: [],
      ageGroup: [],
      medicines: [
        { ...medicines }
      ],
    },
    validationSchema: treatmentPlanValidation,
    onSubmit: async (values, { resetForm }) => {
      const { clone, ...restValue } = values
      let payload = {
        patientId: id,
        providerId: (userdata.roleTitle === RoleTitle.STAFF || userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
        frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
        staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
        roleTitle: userdata.roleTitle,
        name: restValue?.name,
        followUp: restValue?.followUp,
        planType: restValue?.planType,
        planTypeField: restValue?.planType === "Others" ? restValue?.planTypeField : undefined,
        tests: values?.tests?.map((cur) => cur?.name),
        ageGroup: restValue?.ageGroup?.map((cur) => cur?.value),
        rx: values?.medicines?.map((cur) => ({
          ...cur,
          medicineId: cur?.medicine[0]?.medicineId,
          customMedCount: cur?.timeofmedicine === "HOURS" ? cur?.timeofmedicinenumberForHours : cur?.timeofmedicinenumberForDays,
          customMedCountTimeFrame: cur?.medCountType === "STANDARD" ? null : cur?.timeofmedicine,
          timeofmedicine: undefined,
          timeofmedicinenumberForDays: undefined,
          timeofmedicinenumberForHours: undefined,

        })),
      }
      setLoader(true)
      try {
        let response = await ADD_TREATMENT_PLAN(payload)
        resetForm()
        toast.success(response?.message)
        handleOpenModal("add")
        handleClosedModal("clonePlan")
        setFormNumber(0)
        setLoader(false)
        await getTreatmentPlanList()
      } catch (error) {
        toast.error(error?.message)
        setLoader(false)
      }
    },
  });


  const handleAddMedicine = useFormik({
    initialValues: {
      name: "",
      reaction: "",
      unit: "",
      dose: "",
      medicineType: "",
      brandName: "",
      abbr: ""
    },
    validationSchema: medicineValidation,
    onSubmit: async (values, { resetForm }) => {
      const { clone, ...restValue } = values
      setLoader(true)
      let payload = {
        providerId: openModal?.data ? undefined : (userdata.roleTitle === RoleTitle.STAFF || userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
        frontdeskId: openModal?.data ? undefined : userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
        roleTitle: openModal?.data ? undefined : userdata.roleTitle,
        ...restValue,
      }
      try {
        let response = await INSERT_MEDICINE(payload)
        await getMedicineList()
        toast.success(response.message)
        setLoader(false)
        handleClosedModal("addMedicine")
        handleOpenModal("add", openModal?.previoursData)
        resetForm()
      } catch (error) {
        toast.error(error.message)
        setLoader(false)
      }
    }
  })
  const newAddTestsRequested = useFormik({
    initialValues: {
      Tests: ""
    },
    validationSchema: addNewTestsValidation,
    onSubmit: async (values, { resetForm }) => {
      let payload = {
        name: values?.Tests,
        type: "TEST",
        providerId: (userdata.roleTitle === RoleTitle.STAFF || userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
        staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
      }
      try {
        let response = await INSERT_SETUP(payload)
        toast.success(response.message)
        setLoader(false)
        handleClosedModal("tests")
        handleOpenModal("add", openModal?.previoursData)
        await getTesttList()
      } catch (error) {
        toast.error(error.message)
        setLoader(false)
      }
      resetForm()
    }
  })

  // upload pdf/image for test report 
  const uploadPdf = async (e) => {
    if (!e) return
    const fd = new FormData()
    fd.append('file', e)
    fd.append('type', "TESTREPORT")
    fd.append('previousFileName', Url)
    fd.append('id', null)
    setLoader(true)
    try {
      let response = await UPLOAD_FILE_PDF(fd)
      toast.success(response.message)
      setLoader(false)
      setUrl(response?.data?.db_name)
      setUploadReportType(e.type)
    } catch (error) {
      toast.error(error?.message);
      setLoader(false)
    }
  }

  // create test report
  const addReport = useFormik({
    initialValues: {
      title: "",
      description: ""
    },
    validationSchema: addReportValidation,
    onSubmit: async (values, { resetForm }) => {
      if (!Url) {
        return toast.warn("Please upload test report")
      }
      setLoader(true)
      let payload = {
        patientId: AgendaDetails?.id,
        appointmentId: AgendaDetails?.apptId,
        appointmentNumber: AgendaDetails?.apptNumber,
        providerId: (userdata.roleTitle === RoleTitle.STAFF || userdata?.roleTitle === RoleTitle?.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
        staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
        frontdeskId: userdata?.roleTitle === RoleTitle?.FRONT_DESK ? userdata?.userId : undefined,
        roleTitle: userdata?.roleTitle,
        testReport: [{
          fileName: Url,
          description: values?.description,
          title: values?.title,
        }]
      }
      try {
        let response = await INSERT_TEST_REPORT(payload)
        toast.success(response.message)
        resetForm()
        setLoader(false)
        setUrl(null)
        getreportList()
        handleClosedModal("createTestReport")
      } catch (error) {
        toast.error(error.message)
        setLoader(false)
      }
    }
  })
  const addvaccination = useFormik({
    initialValues: {
      category: [],
      vaccinationForm: []
    },
    validationSchema: addvaccinationValidation,
    onSubmit: async (values, { resetForm }) => {
      setLoader(true)
      const payload = {
        patientId: AgendaDetails?.id,
        appointmentNumber: AgendaDetails?.apptNumber,
        appointmentId: AgendaDetails?.apptId,
        providerId: (userdata.roleTitle === RoleTitle.STAFF || userdata?.roleTitle === RoleTitle?.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
        staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
        frontdeskId: userdata?.roleTitle === RoleTitle?.FRONT_DESK ? userdata?.userId : undefined,
        roleTitle: userdata?.roleTitle,
        formDetails: values?.vaccinationForm
      };
      try {
        let response = await ASSIGN_VACCINATION_CALENDAR(payload)
        setLoader(false)
        toast.success(response.message)
        getAssignVaccinationCalendarList()
        getVaccinationCategoryList()
        handleClosedModal("assginVaccination")
      } catch (error) {
        toast.error(error.message)
        setLoader(false)
      }
    }
  })

  const handleChangeTreatmentPlan = (name, value) => {
    setSelectedPlan(value);

    if (value.length === 0) {
      formik.setValues(prevValues => ({
        ...prevValues,
        medicines: [{ ...medicines }]
      }));
      return;
    }

    const selectedPlanIds = value.map(plan => plan.id);
    const selectedTest = value.flatMap(plan => plan?.tests?.map(cur => cur?.testsName));
    const filteredTestList = testReport?.filter(item => selectedTest?.includes(item?.name));

    const selectedMedicines = value.flatMap(plan =>
      plan.rx.map(cur => ({
        medicine: medicineList.filter(item => item?.medicineId === cur?.medicineId) || [],
        medCountType: cur?.medicineIntakeType || "",
        timeofmedicine: cur?.customMedCountTimeFrame || "",
        timeofmedicinenumberForHours: cur?.customMedCountTimeFrame === "HOURS" ? cur?.customMedCount || "" : "",
        timeofmedicinenumberForDays: cur?.customMedCountTimeFrame !== "HOURS" ? cur?.customMedCount || "" : "",
        morningMedCount: cur?.medicineIntakeMorning,
        afternoonMedCount: cur?.medicineIntakeAfternoon,
        nightMedCount: cur?.medicineIntakeEvening,
        duration: cur?.medicineIntakeDurationAmount || "",
        durationTimeFrame: cur?.medicineIntakeDurationType || "",
        quantity: cur?.medicineIntakeAmount || "",
        when: cur?.medicineIntakeTime || "",
        whenCustom: cur?.medicineIntakeCustomTime || "",
        notes: cur?.notes || "",
        prescriptionId: cur?.prescriptionId || undefined,
        providerId: (userdata.roleTitle === RoleTitle.FRONT_DESK) ? userdata?.providerId : userdata?.userId,
        frontdeskId: userdata.roleTitle === RoleTitle.FRONT_DESK ? userdata?.userId : undefined,
        staffId: userdata.roleTitle === RoleTitle.STAFF ? userdata?.userId : undefined,
        planId: plan?.id,
        treatmentPlanId: plan?.id
      }))
    );

    const existingMedicines = Array.isArray(formik?.values?.medicines) ? formik.values.medicines : [];

    const filteredExistingMedicines = existingMedicines.filter(med => selectedPlanIds.includes(med.planId) || med?.planId === null);

    const newMedicines = selectedMedicines.filter(newMed => !filteredExistingMedicines.some(existingMed => existingMed.planId === newMed.planId));
    const updatedMedicines = [...filteredExistingMedicines, ...newMedicines];
    setFormNumber(0)
    formik.setValues(prevValues => ({
      ...prevValues,
      tests: filteredTestList,
      medicines: updatedMedicines,
      followUp: prevValues?.followUp ? prevValues?.followUp : value?.[0]?.followUp
    }));
  };

  const handleDelete = async (event) => {
    if (event === "YES") {
      setLoader(true)
      let payload = {
        patientId: AgendaDetails?.id,
        appointmentId: openModal?.data?.appointmentId,
        type: openModal?.deleteEprescription ? "EPRESCRIPTION" : openModal?.deleteReport ? "TESTREPORT" : "VACCINATIONFORM",
        prescriptionId: openModal?.deleteEprescription ? openModal?.data?.prescriptionId : undefined,
        testReportId: openModal?.deleteReport ? openModal?.data?.testreportId : undefined,
        vaccinationFormId: openModal.deleteVaccination ? [openModal?.data?.vaccinationFormId] : undefined
      }
      try {
        let response = await DELETE_AGENDA(payload)
        toast.success(response.message)
        setLoader(false)
        if (openModal?.deleteEprescription) {
          if (listSelectedMedicines?.length === 1 && controller.page === 1) {
            getListSelectedMedicines()
          }
          else if (listSelectedMedicines?.length === 1) {
            setController((pre) => ({ ...pre, page: controller.page > 1 ? controller.page - 1 : 1 }))
          } else getListSelectedMedicines()

        } else if (openModal.deleteReport) {
          if (MultipleReportData?.length === 1 && controller.page === 1) {
            getreportList()
          }
          else if (MultipleReportData?.length === 1) {
            setController((pre) => ({ ...pre, page: controller.page > 1 ? controller.page - 1 : 1 }))
          } else getreportList()
        }
        else {
          if (assignVaccinationcalenderList?.length === 1 && controller.page === 1) {
            getAssignVaccinationCalendarList()
          }
          else if (assignVaccinationcalenderList?.length === 1) {
            setController((pre) => ({ ...pre, page: controller.page > 1 ? controller.page - 1 : 1 }))
          } else getAssignVaccinationCalendarList()
        }
        handleClosedModal(openModal?.deleteEprescription ? "deleteEprescription" : openModal.deleteReport ? "deleteReport" : "deleteVaccination")
      } catch (error) {
        toast.error(error.message)
        setLoader(false)
      }

    } else {
      handleClosedModal(openModal?.deleteEprescription ? "deleteEprescription" : openModal.deleteReport ? "deleteReport" : "deleteVaccination")
    }

  }

  const handleOpenModal = (type, data = null) => {

    setOpenModal((prev) => ({
      ...prev,
      data: data,
      previoursData: data,
      [type]: true,
    }));
  };

  const handleClosedModal = (type, isNull) => {
    if (type === "tests") {
      newAddTestsRequested.resetForm()
    }
    if (type === "clonePlan") {
      handleClonePlan.resetForm()
    }
    if ("viewVaccinationForm" === type || "downloadVaccinationForm" === type || "printVaccinationForm" === type) {
      setremoveButton(false)
    }
    setOpenModal((pre) => ({
      ...pre,
      data: null,
      previoursData: isNull ? null : pre?.previoursData,
      [type]: false
    }))
  }


  return {
    methods: {
      handleBack,
      handleNext,
      handleChangeLifeStyle,
      LifeStyleTimeFrame,
      openModalFun,
      setModal,
      saveAllData,
      handalSearchAbleSelectBox,
      handleStep,
      ColorlibStepIcon,
      navigate,
      setEPrescriptionViewModal,
      handleOpenModal,
      handleClosedModal,
      formik,
      setFormNumber,
      handleChangeTreatmentPlan,
      setSelectedPlan,
      handleClonePlan,
      handleAddMedicine,
      newAddTestsRequested,
      newAddChronicDisease,
      newAddSymptoms,
      newAddallergies,
      addChronicDisease,
      addDiagnosis,
      AddAllergies,
      addSymptoms,
      handleDelete,
      setController,

      // agenda
      addReport,
      uploadPdf,
      setUrl,
      addvaccination,
      setVaccinationSerialNumberView,
      setremoveButton
    },
    data: {
      controller,
      AgendaDetails,
      selectedPlan,
      treatmentPlanList,
      medicineList,
      formNumber,
      testReport,
      openModal,
      userdata,
      EPrescriptionViewModal,
      CustomButton,
      loader,
      activeStep,
      addVitals,
      LifeStyleList,
      allergiesList,
      symptonData,
      chronicData,
      listSelectedMedicines,
      modal,
      minimumdate,
      addFollowUpDate,
      headCells,
      completed,
      ColorlibConnector,
      steps,
      isFrontDeskPermission,
      paginationTotalCount,

      // agenda
      MultipleReportData,
      Url,
      UploadReportType,
      assignVaccinationcalenderList,
      ListVaccinationCategory,
      VaccinationFormList,
      contentRef,
      componentRef,
      vaccinationSerialNumberView,
      removeButton
    }

  }
}

export default useCheckOut
